import { useMemo } from "react";

function AlbumCabinet ({ listTypeSelector, keyedSongDatabase, currentSongSelection, setCurrentSongSelection }) {
    const songList = keyedSongDatabase.map((track) => track.song);
    const uniqueSongList = [...new Set(songList)];
    uniqueSongList.sort();
    const sessionList = keyedSongDatabase.map((track) => track.session);
    const uniqueSessionList = [...new Set(sessionList)];
    uniqueSessionList.sort();

    const completeSessionSongList = useMemo(() => {
        let tempSessionList = [];
        keyedSongDatabase.forEach((track) => {
            if (!tempSessionList[track.session]) {
                tempSessionList[track.session] = [track];
            } else {
                tempSessionList[track.session].push(track);
            }
        });

        return tempSessionList;        
    }, [keyedSongDatabase]);

    function convertDateFormat(inputDate) {
        // Create a new Date object
        var dateObject = new Date(inputDate);
    
        // Use toLocaleDateString to format the date
        var formattedDate = dateObject.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    
        return formattedDate;
    };

    function selectSong(song) {
        if (song !== keyedSongDatabase[keyedSongDatabase.findIndex((track) => track.key === currentSongSelection)].song) {
            let firstSongTrack = keyedSongDatabase[keyedSongDatabase.findIndex((track) => track.song === song)].key;
            setCurrentSongSelection(firstSongTrack);
        }
    };

    function selectSession(session) {
        if (session !== keyedSongDatabase[keyedSongDatabase.findIndex((track) => track.key === currentSongSelection)].session) {
            let firstSessionTrack = keyedSongDatabase[keyedSongDatabase.findIndex((track) => track.session === session)].key;
            setCurrentSongSelection(firstSessionTrack);
        }
    };

    return <div id="selector-panel">
        {(listTypeSelector === 1) && uniqueSongList.map((item) => (
            <div className="song-box" key={item} onClick={() => selectSong(item)}>
                <h3>{item}</h3>
            </div>)
        )}
        {(listTypeSelector === 2) && uniqueSessionList.map((item) => (
            <div className="session-box" key={item} onClick={() => selectSession(item)}>
                <h3>{convertDateFormat(item)}</h3>
                <ul>
                    {completeSessionSongList[item].map((track, index) => (<li className="tracks" key={index}><small>{track.filename}</small></li>))}
                </ul>
            </div>)
        )}
    </div>
}

export default AlbumCabinet